module.exports = __webpack_public_path__ + "assets/img/banner.e47c5756.png";